import React, {Component, useDebugValue, useSyncExternalStore} from 'react';
import { useState } from "react";
import { FaEdit } from "react-icons/fa";
import { Button, Alert, Modal, Col, FormLabel } from 'react-bootstrap';
import { Navigate } from 'react-router-dom';
import UserService from './services/user.serviceaux';
import RoleService from './services/role.service';
import { useEffect } from 'react';
import { Form, Container, Row } from 'react-bootstrap';
import { useDispatch, } from "react-redux";
import { resetpsw } from "./actions/auth.js";
import { useSelector } from 'react-redux';
import { Controller, useForm } from "react-hook-form";
import { dtForInputDate, dtFormatter } from './AuxiliaryFunctions';


var newDate = new Date();
//var gtDate = newDate.getDate().toString().padStart(2,'0') + '-' + (newDate.getMonth()+1).toString().padStart(2,'0') + '-' + newDate.getFullYear()
var gtDate = new Date().toLocaleString() + ""; 

function UpdateUser(props) { 

  const { control, handleSubmit, formState: { errors },} = useForm({
    defaultValues: {
      /*
      primernombre: props.edituser.primernombre,      
      segundonombre: props.edituser.segundonombre,
      primerapellido: props.edituser.primerapellido,
      segundoapellido: props.edituser.segundoapellido,
      fechadenacimiento: dtForInputDate(props.edituser.fechadenacimiento),
      telefonomovil: props.edituser.telefonomovil,
      email: props.edituser.email,
      habilitado: props.edituser.habilitado,
      curp: props.edituser.curp,
      */
    },
  });  

  const [lgShow, setLgShow] = useState(false);
  const [Errmessage, setErrmessage] = useState("");
  const [Showerror, setShowerror] = useState("");
  const [Sucmessage, setSuccmessage] = useState("");
  const [Showsuccess, setShowsuccess] = useState("");
  const [Submitted, setSubmitted] = useState(false);


  const [primernombre, setPrimernombre] = useState("");
  const [segundonombre, setsegundonombre] = useState("");
  const [primerapellido, setprimerapellido] = useState("");
  const [segundoapellido, setsegundoapellido] = useState("");
  const [fechadenacimiento, setfechadenacimiento] = useState(null);
  const [curp, setcurp] = useState("");
  const [telefonomovil, settelefonomovil] = useState("");
  const [arean1, setarean1] = useState(null);
  const [arean2, setarean2] = useState(null);
  const [imageprofile, setimageprofile] = useState("");
  const [bio, setbio] = useState("");
  const [genero, setgenero] = useState("");
  const [email, setemail] = useState("");
  const [habilitado, sethabilitado] = useState(0);
  
  
  const [username,setUsername] = useState('');


  const [roles,setRoles] = useState([]);
  const [password,setPassword] = useState('');
  const dispatch = useDispatch();

  const [userRoles, setUserRoles] = useState([]);
  // This is how you make the current user available on any functional component
  const { user } = useSelector(state => state.auth);

  const onChangeprimernombre = (e) => {  
    console.log(e.target.value);
    const primernombre = e.target.value;
    setPrimernombre(primernombre);
  };

  const onChangesegundonombre = (e) => {  
    //console.log(e.target.value);
    const segundonombre = e.target.value;
    setsegundonombre(segundonombre);
  };
  
  const onChangeprimerapellido = (e) => {  
    //console.log(e.target.value);
    const primerapellido = e.target.value;
    setprimerapellido(primerapellido);
  };
  
  const onChangesegundoapellido = (e) => {  
    //console.log(e.target.value);
    const segundoapellido = e.target.value;
    setsegundoapellido(segundoapellido);
  };

  const onChangefechadenacimiento = (e) => {  
    console.log(e.target.value);
    const fechadenacimiento = e.target.value;
    setfechadenacimiento(fechadenacimiento);
  };

  const onChangecurp = (e) => {  
    //console.log(e.target.value);
    const curp = e.target.value;
    setcurp(curp);
  };  

  const onChangegenero   = (e) => {  
    console.log(e.target.value);
    const genero = e.target.value;
    setgenero(genero);
  };    

  const onChangetelefonomovil = (e) => {  
    //console.log(e.target.value);
    const telefonomovil = e.target.value;
    settelefonomovil(telefonomovil);
  };  

  const onChangeemail = (e) => {  
    //console.log(e.target.value);
    const email = e.target.value;
    setemail(email);
  };

  const handleClose = () => {
    window.location.reload();
    setLgShow(false);
  }
  
  const handleShow = () => {
    UserService.get(props.userid)
    .then(response => {
        setSuccmessage('');
        setErrmessage('');
        setShowerror(false);
        setShowsuccess(false);      
        setPassword('');  
        setPrimernombre(response.data[0].primernombre);
        setsegundonombre(response.data[0].segundonombre);
        setprimerapellido(response.data[0].primerapellido);
        setsegundoapellido(response.data[0].segundoapellido);
        setemail(response.data[0].email);
        setfechadenacimiento(dtForInputDate(response.data[0].fechadenacimiento));
        settelefonomovil(response.data[0].telefonomovil);
        setcurp(response.data[0].curp);
        setgenero(response.data[0].genero);

        setUsername(response.data[0].username);

        
        setUserRoles(response.data[0].roles.map ((a) => a.id));
        sethabilitado(response.data[0].habilitado);
        setLgShow(true);        
      })      
    .catch(e => {
      console.log(e);
    }); 
    
    RoleService.getAll()
    .then(response => {
        setRoles(response.data);
        //console.log(response.data)
    })      
    .catch(e => {
      console.log(e);
    }); 
    
  }

  let handleValidations = () => {
    /*
    console.log(userRoles.length);
    if (username.length ==0 || userRoles.length == 0) {      
      setErrmessage('Campos requeridos.');
      setShowerror(true);
      return;
    }
    if (email) {
      if (!/\S+@\S+\.\S+/.test(email)) {
        setErrmessage('El correo no es válido.');
        setShowerror(true);      
        return;
      }
    }
    */
    saveUser();
  } 
  
  let onChangeRoles = (e) => {
    // check if checkbox is checked
    if (e.target.checked === true) {
        // check if user role is already assigned to the user
        if (userRoles.includes(e.target.id)) {
            //console.log(userRoles);
            // Do nothing.
        }
        else {
            setUserRoles([...userRoles, parseInt(e.target.id)])
            //console.log(userRoles);
        }
    }
    else {
        // check if user role is already assigned to the user
        if (userRoles.includes(parseInt(e.target.id))) {
            //console.log(userRoles);
            setUserRoles(
                userRoles.filter(a => a !== parseInt(e.target.id))
            );
        }
        else {
            //console.log('value is' + e.target.value);
            //console.log('id is ' + e.target.id);
            //console.log(userRoles);
            // Do nothing.            
        }
    }
  }   

  let onChangeHabilitado = (e) => {  
    const habilitado = e.target.checked == 1?1:0;
    sethabilitado(habilitado);
  }

  let saveUser = (e)  =>{ 
    if (userRoles.length == 0) {
      setErrmessage("El usuario debe tener al menos un rol.");
      setShowerror(true);
    }  
    else {
      var data = {
        primernombre: e.primernombre,
        segundonombre: e.segundonombre,
        primerapellido: e.primerapellido,
        segundoapellido: e.segundoapellido,
        fechadenacimiento: e.fechadenacimiento,
        telefonomovil: e.telefonomovil,
        username: e.username,
        email: e.email,
        roles: userRoles,
        habilitado: habilitado,
        curp: e.curp,
        genero: e.genero,
      }
      
      console.log(data);
      
      UserService.update(props.userid, data)
      .then(response => {
        console.log(response);
        setSubmitted(true);
        setSuccmessage('Se actualizó el usuario. Redirigiendo hacia la lista de usuarios..');
        setShowsuccess(true);
        setErrmessage('');
        setShowerror(false);        
        window.location.assign('/admin-users');
      })
      .catch(e => {
        console.log(e);
        setErrmessage(e.response?e.response.data.message:e.message);
        setShowerror(true);      
        setSuccmessage('');
        setShowsuccess(false);            
      })   
  
    }
    
  }

  let restorePassword = () => {
    var data = {
      userid: props.userid,
      password: Math.random().toString(36).substr(2, 8),
    }    
    dispatch(resetpsw(user.id, data.userid, data.password)) 
    .then(() => {
      setPassword(data.password);
      setShowerror(false);
      setSuccmessage('La contraseña ha sido restablecida. Por favor comparte esta información con ' + props.edituser.primernombre + " " + props.edituser.primerapellido + ".");
      setShowsuccess(true);
    })
    .catch((e) => {
      console.log(e);
      setShowsuccess(false);
      setErrmessage(e.response?e.response.data.message:e.message);
      setShowerror(true);
    });
     
  }

    return (
      <>
        <Button variant="secondary" onClick={handleShow}><FaEdit size={15}/></Button>      
        <Modal
          size="xl"
          show={lgShow}
          onHide={() => {handleClose();setLgShow(false)}}
          aria-labelledby="example-modal-sizes-title-lg"
        >
          <Modal.Header closeButton>
            <Modal.Title id="example-modal-sizes-title-lg">
              {'Actualizar Usuario'}
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>

            <Form noValidate onSubmit={handleSubmit(saveUser)}>
              <Row>
                <Col className='col-md-3' sm={8}>
                  <FormLabel className="mr-5" htmlFor="description">ID Usuario:</FormLabel>
                  <Form.Control className="form-control mb-3"
                    type="text"
                    name="userid"
                    disabled
                    id="userid"
                    value={props.userid}/>
                </Col>
                <Col className='col-md-3' sm={8}>
                  <FormLabel className="mr-5" htmlFor="description">Matrícula:</FormLabel>
                  <Form.Control className="form-control mb-3"
                    type="text"
                    name="matricula"
                    disabled
                    id="matricula"
                    value={props.edituser.matricula}/>
                </Col> 
                <Col className='col-md-3' sm={8}>
                  <FormLabel className="mr-5" htmlFor="created">Fecha de creación:</FormLabel>
                  <Form.Control className="form-control mb-3"
                    type="text"
                    name="created"
                    disabled
                    id="created"
                    value={dtFormatter(new Date(props.edituser.createdAt),2)}/>
                </Col>                                              
              </Row>
              <Row className='mt-2'>
                <Col className='col-md-3' sm={8}>
                    <Controller
                      name="primernombre"
                      control={control}
                      onChange={onChangeprimernombre}
                      defaultValue={primernombre}
                      rules={{ required: true }}
                      render={({ field }) => (
                        <Form.Control
                          {...field}
                            className="m-2"
                            type="text"
                            placeholder="Primer nombre"
                            isInvalid={errors.primernombre}
                            //onChange={onChangeprimernombre}
                            //value={username}
                            
                        />
                      )}
                    />
                    {errors.primernombre && (
                      <Form.Control.Feedback type="invalid">
                        Se requiere el nombre
                      </Form.Control.Feedback>
                    )}
                </Col>
                <Col className='col-md-3' sm={8}>
                  <Controller
                    name="segundonombre"
                    control={control}
                    onChange={onChangesegundonombre}
                    defaultValue={segundonombre}
                    rules={{ required: false }}
                    render={({ field }) => (
                      <Form.Control
                        {...field}
                          className="m-2"
                          type="text"
                          placeholder="Segundo nombre"
                          isInvalid={errors.username}
                          //onChange={onChangesegundonombre}
                          //value={username}
                          
                      />
                    )}
                  />
                  {errors.username && (
                    <Form.Control.Feedback type="invalid">
                      Se requiere el nombre
                    </Form.Control.Feedback>
                  )}        
                </Col>

                <Col className='col-md-3' sm={8}>
                  <Controller
                    name="primerapellido"
                    control={control}
                    onChange={onChangeprimerapellido}
                    defaultValue={primerapellido}
                    rules={{ required: true }}
                    render={({ field }) => (
                      <Form.Control
                        {...field}
                          className="m-2"
                          type="text"
                          placeholder="Primer apellido"
                          isInvalid={errors.primerapellido}
                          //onChange={onChangeprimerapellido}
                          //value={username}
                          
                      />
                    )}
                  />
                  {errors.primerapellido && (
                    <Form.Control.Feedback type="invalid">
                      Se requiere el primer apellido
                    </Form.Control.Feedback>
                  )} 
                </Col>

                <Col className='col-md-3' sm={8}>
                  <Controller
                    name="segundoapellido"
                    control={control}
                    onChange={onChangesegundoapellido}
                    defaultValue={segundoapellido}
                    rules={{ required: false }}
                    render={({ field }) => (
                      <Form.Control
                        {...field}
                          className="m-2"
                          type="text"
                          placeholder="Segundo apellido"
                          isInvalid={errors.username}
                          //onChange={onChangesegundoapellido}
                          //value={username}
                          
                      />
                    )}
                  />
                  {errors.username && (
                    <Form.Control.Feedback type="invalid">
                      Se requiere el segundo apellido
                    </Form.Control.Feedback>
                  )}           
                </Col>

              </Row>

              <Row className='mt-2'>
                <Col className='col-md-3' sm={8}>
                  <FormLabel className="m-2">Fecha de Nacimiento</FormLabel>
                  <Controller
                    name="fechadenacimiento"
                    control={control}
                    onChange={onChangefechadenacimiento}
                    defaultValue={fechadenacimiento}
                    rules={{ required: true }}
                    render={({ field }) => (
                      <Form.Control
                        {...field}
                          className="m-2"
                          type="date"
                          placeholder="fecha de nacimiento"
                          isInvalid={errors.fechadenacimiento}
                          //onChange={onChangefechadenacimiento}
                          //value={username}
                          
                      />
                    )}
                  />
                  {errors.fechadenacimiento && (
                    <Form.Control.Feedback type="invalid">
                      Se requiere la fecha de nacimiento.
                    </Form.Control.Feedback>
                  )}             
                </Col>

                <Col className='col-md-3' sm={8}>
                  <FormLabel className="m-2">Teléfono móvil</FormLabel>
                  <Controller
                    name="telefonomovil"
                    control={control}
                    onChange={onChangetelefonomovil}
                    defaultValue={telefonomovil}
                    rules={{ required: true, pattern: /^\d{10}$/ }}                    
                    render={({ field }) => (
                      <Form.Control
                        {...field}
                          className="m-2"
                          type="number"                                           
                          isInvalid={errors.telefonomovil}
                          //onChange={onChangetelefonomovil}
                          //value={props.email}
                          
                      />
                    )}
                  />
                  {(errors.telefonomovil) && (
                    <Form.Control.Feedback type="invalid">
                      El teléfono móvil debe tener diez dígitos.
                    </Form.Control.Feedback>               
                  )}  
                </Col>

                <Col className='col-md-3' sm={8}>
                  <FormLabel className="m-2">Email</FormLabel>
                  <Controller
                    name="email"
                    control={control}
                    onChange={onChangeemail}
                    defaultValue={email}
                    rules={{ required: true }}
                    render={({ field }) => (
                      <Form.Control
                        {...field}
                          className="m-2"
                          type="text"
                          isInvalid={errors.email}
                          //onChange={onChangeemail}
                          //value={username}
                          
                      />
                    )}
                  />  
                  {errors.email && (
                    <Form.Control.Feedback type="invalid">
                      Se requiere el email.
                    </Form.Control.Feedback>
                  )} 
                </Col>       

                <Col className='col-md-3' sm={8}>
                  <FormLabel className="m-2">CURP</FormLabel>
                  <Controller
                    name="curp"
                    control={control}
                    onChange={onChangecurp}
                    defaultValue={curp}
                    rules={{ required: false }}
                    render={({ field }) => (
                      <Form.Control
                        {...field}
                          className="m-2"
                          type="text"
                          isInvalid={errors.curp}
                          //onChange={onChangeemail}
                          //value={username}
                          
                      />
                    )}
                  />  
                  {errors.email && (
                    <Form.Control.Feedback type="invalid">
                      Se requiere la CURP.
                    </Form.Control.Feedback>
                  )} 
                </Col>                       
              </Row>

              <Row className='mt-2'>
                <FormLabel className="m-2">Género</FormLabel>
                <Col className='col-md-3' sm={8}>
                  <Controller
                    name="genero"
                    control={control}
                    onChange={onChangegenero}
                    defaultValue={genero}
                    rules={{ required: true }}
                    render={({ field }) => (
                      <Form.Select aria-label="Default select example"
                        {...field}
                        isInvalid={errors.genero}>                        
                        <option>Seleccionar</option>
                        <option value="M">Masculino</option>
                        <option value="F">Femenino</option>
                      </Form.Select> 
                    )}
                  />
                  {errors.genero && (
                    <Form.Control.Feedback type="invalid">
                      Se requiere el género
                    </Form.Control.Feedback>
                  )}
                </Col>  
              </Row>
              <hr />

              <Row className='mt-2'>
                <h5>Roles de usuario</h5>
                {roles.map((row, index) => {  
                    //console.log(userRoles);
                    //var userroleids = userRoles?userRoles.map(function (el) { return el; }):[];
                    return (

                      <div className='mb-3 sm-0' style={{width:'250px'}}>
                          <Form.Check 
                            style={{display:'flex',flexDirection:'row',alignItems:'center', gap:'20px'}}
                              type={'checkbox'}
                              id={row.id}
                              label={row.rolename}
                              defaultChecked={(userRoles.includes(row.id))?true:false}
                              onChange={onChangeRoles}
                          />
                      </div>
                    )
                })}
              </Row>
              <hr />

              <Row className='mt-2'>
                <div className='mb-3 sm-0'>
                  <Row>
                    <FormLabel style={{width:'50px'}}>Habilitado</FormLabel>
                    <Form.Check 
                      style={{display:'flex',flexDirection:'row',alignItems:'center', gap:'10px', width:'100px'}}
                        type={'checkbox'}
                        defaultChecked={(props.edituser.habilitado == 1)?true:false}
                        onChange={onChangeHabilitado}
                    />
                    <Alert style={{width:'80%'}}>
                      Solo usuarios con perfil habilitado pueden ser seleccionados como jueces en competencias.
                    </Alert>
                  </Row>
                </div>
              </Row>
              {/*
              <button className="btn btn-secondary btn-block">
                Guardar
              </button>              
              */}

              <hr />

              <Col>
                <Row>
                  <label className="mr-5" htmlFor="description">Contraseña:</label>
                </Row>
                <Row>
                  <Col>                  
                    <input className="form-control mb-3"
                      type="text"
                      name="password"
                      disabled
                      id="password"
                      value={password}/>
                  </Col>
                  <Col>
                    <Button variant="secondary" onClick={restorePassword}>
                      Restablecer contraseña
                    </Button>                 
                  </Col> 
                </Row>              
              </Col>

              <hr/>
              <div className="d-flex justify-content-start flex-wrap">      
         
                <button className="btn btn-secondary btn-block">
                  Guardar y cerrar
                </button>            
              </div> 

            </Form>

          
              {Showerror && (
                <Alert variant="danger" onClose={() => setShowerror(false)} dismissible>
                  <Alert.Heading>Error</Alert.Heading>
                  <p>{Errmessage}</p>
                </Alert>      
              )}
              {Showsuccess && (
                <Alert variant="success" onClose={() => setShowsuccess(false)} dismissible>
                  <Alert.Heading>Done</Alert.Heading>
                  <p>{Sucmessage}</p>
                </Alert>      
              )}     
              {/*{Submitted ? (<Navigate push to="/admin-users"/>) : null }                                                   */}
          </Modal.Body>
        </Modal>
      </>
    );
  }

  
  export default UpdateUser;